import React from "react";
import "../small-card/styles.css";
import Text from "../../typography/text.js";
import ChangeIndicator from "../../change-indicator/change-indicator.js";
import { Skeleton } from "antd";

const SmallCard = ({
  loading = false,
  title,
  number,
  percent,
  indicatorVariant,
  date,
}) => {
  const ValueSkeleton = (
    <Skeleton.Input active size="small" style={{ width: 40 }} />
  );

  return (
    <div className="small-card-container">
      <div className="small-card-content">
        <div className="card-content-child-container">
          <Text variant="tinyText">{title}</Text>
        </div>

        {loading ? (
          ValueSkeleton
        ) : (
          <Text variant="numberBig">{number}</Text>
        )}

        {loading ? (
          ValueSkeleton
        ) : (
          percent && (
            <ChangeIndicator
              variant={indicatorVariant}
              percent={percent}
            />
          )
        )}
      </div>

      {date ? (
        <div className="small-card-bottom">
          {loading ? (
            <Skeleton.Input active size="small" style={{ width: 60 }} />
          ) : (
            <Text variant="tinyText">{date}</Text>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default SmallCard;